import ACTION_TYPES from "../ActionTypes";

const { CAMPAIGN } = ACTION_TYPES;

// MAIN CAMPAIGN REDUCER
interface PriorityCampaignState {
  priortiyCampaignData: { data: any[]; totalRows: number }; // Tambahkan totalRows
  error: any | null;
  loading: boolean;
  searchText: string;
}

const priorityCampaignValue: PriorityCampaignState = {
  priortiyCampaignData: { data: [], totalRows: 0 }, // Tambahkan totalRows
  error: null,
  loading: false,
  searchText: "",
};

export const ReducerPriorityCampign = (
  state = priorityCampaignValue,
  action: any
) => {
  switch (action.type) {
    case CAMPAIGN.GET_PRIORITY_CAMPAIGN_START:
      return {
        ...state,
        loading: true,
        error: null,
        priortiyCampaignData: action.meta?.keepData 
          ? state.priortiyCampaignData 
          : { data: [], totalRows: 0 }
      };

    case CAMPAIGN.GET_PRIORITY_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        priortiyCampaignData: {
          data: action.meta?.replaceData
            ? action.payload.data
            : [...(state.priortiyCampaignData?.data || []), ...action.payload.data],
          totalRows: action.payload.totalRows
        }
      };

    case CAMPAIGN.GET_PRIORITY_CAMPAIGN_FAILED:
      return { ...state, loading: false, error: action.payload };

      case "SET_SEARCH_TEXT":
        return {
          ...state,
          searchText: action.payload,
          // Reset data jika search berubah
          priortiyCampaignData: action.meta?.immediateSearch 
            ? { data: [], totalRows: 0 }
            : state.priortiyCampaignData
        };

    default:
      return state;
  }
};
// GET ID CAMPAIGN REDUCER
const idCampaignValue = {
  idCampaignData: [],
  error: null,
  loading: false,
};

export const ReducerIdCampaign = (state = idCampaignValue, action) => {
  switch (action.type) {
    case CAMPAIGN.GET_ID_CAMPAIGN_START:
      return { ...state, loading: true };
    case CAMPAIGN.GET_ID_CAMPAIGN_FAILED:
      return { ...state, error: action.payload, loading: false };
    case CAMPAIGN.GET_ID_CAMPAIGN_SUCCESS:
      return { ...state, idCampaignData: action.payload, loading: false };
    default:
      return state;
  }
};

// POST CAMPAIGN REDUCER
const regisCampaignValue = {
  regisCampaignData: [],
  error: null,
  loading: false,
};

export const ReducerRegisCampaign = (state = regisCampaignValue, action) => {
  switch (action.type) {
    case CAMPAIGN.POST_FORM_CAMPAIGN_START:
      return { ...state, loading: true };
    case CAMPAIGN.POST_FORM_CAMPAIGN_FAILED:
      return { ...state, error: action.payload, loading: false };
    case CAMPAIGN.POST_FORM_CAMPAIGN_SUCCESS:
      return { ...state, regisCampaignData: action.payload, loading: false };
    default:
      return state;
  }
};

// GET CATEGORY CAMPAIGN
const categoryCampaign = {
  categoryCampaignData: [],
  error: null,
  loading: false,
};

export const ReducerCategoryCampaign = (state = categoryCampaign, action) => {
  switch (action.type) {
    case CAMPAIGN.GET_CATEGORY_CAMPAIGN_START:
      return { ...state, loading: true };
    case CAMPAIGN.GET_CATEGORY_CAMPAIGN_FAILED:
      return { ...state, error: action.payload, loading: false };
    case CAMPAIGN.GET_CATEGORY_CAMPAIGN_SUCCESS:
      return { ...state, categoryCampaignData: action.payload, loading: false };
    default:
      return state;
  }
};
